// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8e4fb697","732":"5fb599f8","977":"7baf3c3d"}[chunkId] + ".chunk.js";
};